import React from 'react';
import { useTranslation } from 'react-i18next';
import { resolveResultView } from '../../pages/picture-ai/registry';

/**
 * Render one analysis with the view its agent asked for.
 *
 * The name comes from the agent descriptor when the caller has it, and from the agent key stored
 * on the result otherwise — an old analysis is readable even if its configuration changed since.
 * A name this build does not know falls back to the raw envelope with a banner, so a backend
 * deployed ahead of the frontend degrades instead of breaking the screen.
 */
const AnalysisOutput = ({ output, agent, configParams }) => {
  const { t } = useTranslation();
  if (!output) return null;

  const requested = agent?.ui_descriptor?.resultView;
  const fallbackName = output.agent_key === 'compliance' ? 'compliance-verdict' : 'visual-context';
  const View = resolveResultView(requested) || (requested ? null : resolveResultView(fallbackName));

  if (!View) {
    return (
      <div className="space-y-2">
        <p className="rounded-lg bg-amber-50 p-3 text-sm text-amber-800 dark:bg-amber-950/40 dark:text-amber-200">
          {t('This agent needs a more recent version of the interface; showing the raw result.')}
        </p>
        <pre className="overflow-x-auto rounded-xl bg-gray-950 p-4 text-xs text-gray-100">{JSON.stringify(output, null, 2)}</pre>
      </div>
    );
  }

  return <View output={output} configParams={configParams} />;
};

export default AnalysisOutput;
